var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-lg":"","text-center":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","fill-height":""}},[_c('v-flex',{staticClass:"text-center"},[_c('p',[_vm._v("Logging out...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }